module.exports = __webpack_public_path__ + "static/img/intro-img.0bb8adf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/intro-img.jpg
// module id = IrS6
// module chunks = 2